import script from "./ProfileCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileCard.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/styles/shared-styles.css?vue&type=style&index=0&lang=css&external"
import "./ProfileCard.vue?vue&type=style&index=1&id=2017eb27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2017eb27"]])

export default __exports__